<template>
  <app-layout>
  <template v-slot:adminnav >
  </template> 

 <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 mt-2">
      <div class="w-full">
        <div class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
            
          <div class="text-lg font-bold mb-2">Create Branch</div> 

            <form @submit.prevent="update">
              <BsEdit :createDef="createDef" :slug="slug" :routeDef="moduleRoute" :modelData="modelData" ref="formRenderer"> </BsEdit>

              <div class="px-4 py-3  text-right sm:px-6">
              <jet-button type="submit" @click="saveRecord" class="bg-blue-500 rounded text-sm pl-2 pr-2 pt-1 pb-1 text-white hover:no-underline"> Save </jet-button>
            </div>     
              </form>




        </div>
      </div>
    </div>
 
</app-layout>

</template>
<script>  
import JetNavLink from '@/Jetstream/NavLink.vue';
import AppLayout from "@/Layouts/AppLayout.vue";
import BsEdit from "@/Base/BsEdit.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import DxTextBox from 'devextreme-vue/text-box';
import { DxToast } from 'devextreme-vue/toast';


import {
    DxForm,
    DxSimpleItem,
    DxGroupItem,
} from 'devextreme-vue/form';
const modelData = {};
export default {
  props: {
  createDef: Array,
    moduleRoute: String,
    moduleName:  String,
    slug:String,
    modelData:{
        type: Object,
        default: () => ({})
    },
    
  },
  components: {
    AppLayout,
    BsEdit,
    PageTitle,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxTextBox,
    JetNavLink,
    DxToast
  },
  data: function () {
    return {
    
    };
  },
  methods: {
    saveRecord()
    {
        
        //console.log(this.$refs.formRenderer.formData);
        this.$inertia.post('/'+this.slug+'/'+this.moduleRoute, this.$refs.formRenderer.formData)

       // this.$inertia.put(route('tenant-lists.update',this.modelData.id),this.$refs.formRenderer.formData)
        
    }  
    
  },
  mounted() {

     
  },


};
</script>
<style>
.main-content {
  background-color: #f3f4f6;
 
  margin-left: 212px;
  padding-bottom: 10px;
} 
.edit_view{
  height: 84vh;
}
.btn-close {
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  font-size: 20px;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  color: #2A66B1;
  background: transparent;
}
.modal-header {
  position: relative;
  border-bottom: 1px solid #EEEEEE;
  color: #2A66B1;
  justify-content: space-between;  
}
</style>